(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.AmphrCheckoutPayload = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function round2(n) { return Math.round(n * 100) / 100; }

  function bucketDiscounts(cart) {
    var buckets = [];
    var byTitle = {};
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var title = (alloc.discount_application && alloc.discount_application.title) || 'Discount';
        byTitle[title] = (byTitle[title] || 0) + alloc.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      byTitle[app.title] = (byTitle[app.title] || 0) + app.total_allocated_amount;
    });
    var sentCents = 0;
    Object.keys(byTitle).forEach(function (title) {
      buckets.push({ name: title, amountCents: byTitle[title] });
      sentCents += byTitle[title];
    });
    var totalDiscountCents = typeof cart.total_discount === 'number' ? cart.total_discount : (cart.total_discounts || 0);
    return {
      buckets: buckets,
      sentMdl: round2(sentCents / 100),
      leftoverCents: totalDiscountCents - sentCents,
    };
  }

  function buildDiscountCodes(cart) {
    return bucketDiscounts(cart).buckets.map(function (b) {
      return { code: b.name, amount: round2(b.amountCents / 100), type: 'fixed_amount' };
    });
  }

  function buildPayload(cart, form, shipping) {
    return {
      amount: round2(cart.total_price / 100 + shipping.deliveryMdl),
      currency: cart.currency || 'MDL',
      description: (cart.items || []).map(function (i) { return i.quantity + 'x ' + i.title; }).join(', '),
      customerName: form.customerName,
      email: form.email,
      phone: form.phone,
      address1: form.address1,
      address2: form.address2 || '',
      city: form.city,
      province: form.province || '',
      zip: form.zip || '',
      country: form.country,
      country_code: form.country_code,
      buyer_accepts_marketing: !!form.buyer_accepts_marketing,
      paymentType: form.paymentType,
      delivery: round2(shipping.deliveryMdl),
      shippingTitle: shipping.shippingTitle,
      products: (cart.items || []).map(function (i) {
        return { variant_id: i.variant_id, quantity: i.quantity, price: round2(i.original_price / 100) };
      }),
      items: (cart.items || []).map(function (i) {
        return { title: i.title, quantity: i.quantity, amount: round2(i.original_price / 100) };
      }),
      discount_codes: buildDiscountCodes(cart),
    };
  }

  function verifyPayload(payload, cart) {
    var errors = [];
    var catalogTotal = (cart.items || []).reduce(function (s, i) { return s + i.original_price * i.quantity; }, 0) / 100;
    var discounts = (payload.discount_codes || []).reduce(function (s, d) { return s + d.amount; }, 0);
    var reconstructed = round2(catalogTotal + payload.delivery - discounts);
    if (Math.abs(reconstructed - payload.amount) > 0.011) {
      errors.push('Invariant picat: catalog ' + round2(catalogTotal) + ' + delivery ' + payload.delivery + ' - discounturi ' + round2(discounts) + ' = ' + reconstructed + ' != amount ' + payload.amount);
    }
    var displayed = round2(cart.total_price / 100 + payload.delivery);
    if (Math.abs(displayed - payload.amount) > 0.011) {
      errors.push('amount ' + payload.amount + ' difera de totalul afisat clientului ' + displayed);
    }
    var b = bucketDiscounts(cart);
    if (b.leftoverCents !== 0) {
      errors.push('Discount netratat (conservarea numerelor): ' + b.leftoverCents + ' cents din cart.total_discount nu au galeata');
    }
    if (payload.amount <= 0) {
      errors.push('Suma de plata este zero — comanda nu poate fi trimisa online');
    }
    (payload.discount_codes || []).forEach(function (d) {
      if (d.type !== 'fixed_amount') errors.push('discount_codes accepta doar fixed_amount aici, gasit: ' + d.type);
    });
    return { ok: errors.length === 0, errors: errors };
  }

  return {
    round2: round2,
    bucketDiscounts: bucketDiscounts,
    buildDiscountCodes: buildDiscountCodes,
    buildPayload: buildPayload,
    verifyPayload: verifyPayload,
  };
});
